import React, { memo, useCallback } from 'react';
import { NavLink, useParams } from 'react-router-dom';

import { refMapper } from 'services';
import { classer } from 'utils';

import SubMenu from './SubMenu';
import { Colors } from 'themes/colors';
import ArrowUp from 'components/ui/icons/ArrowUp';

import classes from '../Drawer.module.scss';

const Section = ({
  item,
  index,
  setContentRendered,
  activeName,
  expandedTabsMap,
  hideDrawer,
  onClickSelectSection
}) => {
  const { bu, lang } = useParams();

  const { name, pages, title } = item;
  const expanded = !!expandedTabsMap?.[name]?.expanded;
  const isActiveParent = activeName === name;

  const onClickLink = useCallback(() => {
    hideDrawer();
    onClickSelectSection({ name });
  }, [hideDrawer, name, onClickSelectSection]);

  if (!pages) {
    return (
      <li className={classes.TreeItem} key={`${name}${index}`}>
        <NavLink
          activeClassName={classes.ActiveNavLink}
          to={`/${bu}/${name}/${lang}`}
          onClick={onClickLink}
        >
          {title}
        </NavLink>
      </li>
    );
  }

  return (
    <React.Fragment key={`${name}${index}`}>
      <li className={classes.TreeItem}>
        <button
          className={classes.Page}
          onClick={() => onClickSelectSection({ name, pages })}
          ref={ref => {
            if (!ref) return;
            refMapper.setOuterElementRef(name, ref);
            setContentRendered(true);
          }}
          type="button"
          aria-expanded={expanded}
        >
          <div
            className={classer([
              classes.PageInner,
              isActiveParent && classes.Active
            ])}
          >
            <span
              className={classer([classes.Name, expanded && classes.Active])}
            >
              {title}
            </span>

            <ArrowUp
              size={15}
              fill={Colors.white}
              className={classer([
                classes.ArrowIcon,
                expanded && classes.ActiveIcon
              ])}
            />
          </div>
        </button>
      </li>

      <SubMenu
        name={name}
        options={pages}
        expanded={expanded}
        isActiveParent={isActiveParent}
        hideDrawer={hideDrawer}
        setChildRef={(childIdentificator, ref) => {
          refMapper.setChildRef(name, childIdentificator, ref);
        }}
        onClickSelectSection={onClickSelectSection}
      />
    </React.Fragment>
  );
};

export default memo(Section);
